const actions = {
  SET_STATE: 'country/SET_STATE',
  REFRESH_ERRORS: 'country/REFRESH_ERRORS',
  ALL: 'country/ALL',
  FETCH_ALL: 'country/FETCH_ALL',
  DETAILS: 'country/DETAILS',
  ADD: 'country/ADD',
  EDIT: 'country/EDIT',
  REMOVE: 'country/REMOVE'
};

export default actions
